import { useState } from 'react';
import ThItem from './ThItem';

declare interface ThItemWrapperProps {
    items: ({ title: string; isSortable: boolean; isSelected?: boolean; isReversed?: boolean } | string)[];
    /**
     * index of the default selected item
    */
    defaultOrder?: number;
    reversedDefault?: boolean;
    onChange?: (title: string, reversed?: boolean) => void;
}

const ThItemWrapper = ({ items, defaultOrder = 0, reversedDefault = false, onChange }: ThItemWrapperProps) => {
    const [state, setState] = useState<{ [key: string]: { selected: boolean; reverse: boolean } }>(
        items.reduce((acc, item, index) => {
            let key;
            let selected;
            let reversed;

            if (typeof item !== 'string') {
                key      =  item.title;
                selected = item?.isSelected || index === defaultOrder;
                reversed = item?.isReversed || reversedDefault;
            } else {
                key      = item;
                selected = index === defaultOrder;
                reversed = reversedDefault;
            }

            return { ...acc, [key]: { selected, reverse: reversed } };
        }, {})
    );

    const handleClick = (title) => {
        setState((prev) => {
            if (prev[title].selected){
                onChange?.(title, !prev[title].reverse);

                return ({
                    ...prev,
                    [title]: { selected: true, reverse: !prev[title].reverse }
                });
            }

            onChange?.(title, false);

            return {
                ...items.reduce((acc, item) => {
                    let key;

                    if (typeof item !== 'string') {
                        key =  item.title;
                    } else {
                        key = item;
                    }

                    return { ...acc, [key]: { selected: false, reverse: false } };
                }, {}),
                [title]: { selected: true, reverse: false }
            };
        });
    };

    return (
        <>
            {
                items.map((item, index) => {
                    let key;
                    let isSortable = true;
                    let isReversed;

                    if (typeof item !== 'string') {
                        key        =  item.title;
                        isSortable = item.isSortable ?? true;
                        isReversed = item?.isReversed || state[key].reverse;
                    } else {
                        key        = item;
                        isReversed = state[key].reverse;
                    }

                    return (
                        <ThItem
                            key={index}
                            title={key}
                            isActive={state[key].selected}
                            isReversed={isReversed}
                            onClick={() => handleClick(key)}
                            isSortable={isSortable}
                        />
                    );
                })
            }
        </>
    );
};

export default ThItemWrapper;
